'use client';
import { memo, useState } from 'react';
import { Flex, VStack } from '@chakra-ui/react';

import { breakpoints } from 'app/themeConfig';
import SliderControls from 'features/SliderControls';
import ReviewCard from 'entities/ReviewCard';
import Slider from 'shared/Slider';
import BlockHeader from 'shared/BlockHeader';
import { useSwiperControls } from 'shared/hooks';

import { reviewsPropsSelector } from 'constants/Reviews';

const Reviews = ({ type = 'default', titleProps = null }) => {
  const { cardsData, slidesStyles, titleProps: titlePropsFromData } = reviewsPropsSelector[type];
  const [swiper, setSwiper] = useState(null);
  const controls = useSwiperControls(swiper);

  return (
    <VStack
      as="section"
      w="full"
      align="start"
      gap={{ mobile: '20px', tablet: '24px', laptop: '48px' }}
    >
      <Flex w="full" justify="space-between">
        <BlockHeader {...(titleProps ?? titlePropsFromData)}>Что о нас говорят</BlockHeader>

        <SliderControls gap={{ mobile: '8px', laptop: '16px' }} {...controls} />
      </Flex>

      <Slider
        controller={swiper}
        setController={setSwiper}
        slidesData={cardsData}
        SlideComponent={ReviewCard}
        slideStyle={slidesStyles}
        mousewheel={false}
        spaceBetween="8px"
        breakpoints={{
          [parseInt(breakpoints.xm)]: { slidesPerView: 'auto' },
          [parseInt(breakpoints.tablet)]: { slidesPerView: 'auto', spaceBetween: '10px' },
          [parseInt(breakpoints.laptop)]: { slidesPerView: 'auto', spaceBetween: '20px' },
        }}
      />
    </VStack>
  );
};

export default memo(Reviews);
